import { Theme } from "@mui/material"

export const SSO_ICON_COLUMN_WIDTH = 25
export const SSO_ICON_TEXT_GAP = 10
export const SSO_BUTTON_HEIGHT = "40px"
export const SSO_BUTTON_BORDER_RADIUS = "8px"

export const ssoButtonBaseSx = {
  position: "relative",
  justifyContent: "center",
  height: SSO_BUTTON_HEIGHT,
  borderRadius: SSO_BUTTON_BORDER_RADIUS,
  padding: 0,
  minWidth: 0,
}

export const ssoOutlinedButtonSx = (theme: Theme) => ({
  ...ssoButtonBaseSx,
  border: `1px solid ${theme.palette.mockup.neutral90}`,
  color: theme.palette.mockup.neutral10,
})

export const ssoGoogleButtonSx = (theme: Theme) => ({
  ...ssoOutlinedButtonSx(theme),
  width: "100%",
  maxWidth: "100%",
  overflow: "hidden",
})

export const ssoButtonVisualLayerSx = {
  position: "absolute",
  inset: 0,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  pointerEvents: "none",
}

export const ssoContentRootSx = {
  display: "flex",
  alignItems: "center",
  gap: `${SSO_ICON_TEXT_GAP}px`,
  maxWidth: "100%",
}

export const ssoIconCellSx = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: SSO_ICON_COLUMN_WIDTH,
  flexShrink: 0,
}

export const ssoTextCellSx = {
  minWidth: 0,
  textAlign: "left",
}

export const ssoGoogleHiddenTargetSx = (
  isSignUp: boolean,
  checked?: boolean,
) => ({
  position: "absolute",
  inset: 0,
  zIndex: 1,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  // Chromium FedCM treats opacity:0 as non-interactive (anti-clickjacking)
  opacity: 0.01,
  overflow: "hidden",
  cursor: "pointer",
  ...(isSignUp ? { pointerEvents: checked ? "auto" : "none" } : {}),
})
